import { Icon, TooltipHost } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CornIcon, TimeApprovedIcon } from '../Icons';
import { TimeIconWhite } from '../Icons/TimeIconWhite';
import { useUiContext } from './Contexts/UIContext/uiCtx';
import { useConfigValuesState } from '../hooks/useConfigValue';

export function NavHeader() {
    const { t } = useTranslation('common');
    const { showNavbar } = useUiContext();
    const location = useLocation();

    const [hashPath, setHashPath] = useState(window.location.hash);
    const isTimesheetPage = hashPath === '#/' || hashPath === '';

    useEffect(() => {
        setHashPath(window.location.hash);
    }, [location]);

    const {
        initialData: {
            configuration: {
                nativeChartsEnabled,
                approval: { projectManagerApproval },
            },
            aggregatedUser: { user, delegatedUsers },
        },
    } = useConfigValuesState();

    if (!showNavbar) {
        return null;
    }

    return (
        <div className="topbar-container">
            <div className="corn">
                <a href="https://www.office.com/">
                    <CornIcon />
                </a>
            </div>
            <div className="head" style={{ display: 'flex' }}>
                <span className="headTitle">Time</span>

                {!isTimesheetPage && (
                    <Link to="/" style={{ marginLeft: 'auto', marginRight: '20px', color: 'white' }}>
                        <TooltipHost content={t('navigation.tooltip.time')} id="TimeIconWhite">
                            <TimeIconWhite />{' '}
                        </TooltipHost>
                    </Link>
                )}
                {isTimesheetPage && (
                    <Link to="/approve" style={{ marginLeft: 'auto', marginRight: '20px', color: 'white' }}>
                        <TooltipHost content={t('navigation.tooltip.approval')} id="TimeIconWhite">
                            <TimeApprovedIcon />
                        </TooltipHost>
                    </Link>
                )}
                {nativeChartsEnabled && (
                    <Link to="/charts" id={'tft-charts'} style={{ marginRight: '20px', marginTop: -2, color: 'white' }}>
                        <TooltipHost content={t('navigation.tooltip.charts')} id="TimeIconWhite">
                            <Icon style={{ fontSize: 20 }} iconName="BarChartVerticalFill" />
                        </TooltipHost>
                    </Link>
                )}
                {user.isProjectManager && projectManagerApproval?.enabled && (
                    <Link to="/project-approval" style={{ marginRight: '20px', marginTop: -2, color: 'white' }}>
                        <TooltipHost content={t('navigation.tooltip.projectApproval')} id="TimeIconWhite">
                            <Icon style={{ fontSize: 20 }} iconName="InboxCheck" />
                        </TooltipHost>
                    </Link>
                )}
                {(user.isAdmin || delegatedUsers.length > 0) && (
                    <Link to="/admin" style={{ marginRight: '20px', marginTop: -2, color: 'white' }}>
                        <TooltipHost content={t('navigation.tooltip.settings')} id="TimeIconWhite">
                            <Icon style={{ fontSize: 20 }} iconName="Settings" />
                        </TooltipHost>
                    </Link>
                )}
                <Link to="/help" id={'tft-help'} style={{ marginRight: '20px', marginTop: -2, color: 'white' }}>
                    <TooltipHost content={t('navigation.tooltip.help')} id="TimeIconWhite">
                        <Icon style={{ fontSize: 20 }} iconName="Help" />
                    </TooltipHost>
                </Link>
            </div>
        </div>
    );
}
